import { useState, MouseEvent, FC } from 'react';

import { Wallet, Contact } from 'lucide-react';
import { BaseMenu, BaseMenuItem } from 'wbs-components-lib';

import { UserTableActionsMenuProps } from './types';

export const UserTableActionsMenu: FC<UserTableActionsMenuProps> = ({
  userProgress,
  handleUserProgressEditModalOpen,
  handleAssignUserModalOpen,
}) => {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);
  const isMenuOpened = Boolean(menuAnchor);

  const handleOpenMenu = (event: MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchor(null);
  };

  const { userId } = userProgress;

  const menuItems: BaseMenuItem[] = [
    {
      icon: <Wallet />,
      text: 'Configure Reward Chance',
      onClick: () => handleUserProgressEditModalOpen(userId),
    },
    {
      icon: <Contact />,
      text: 'Assign Referral',
      onClick: () => handleAssignUserModalOpen(userId),
    },
  ];

  return (
    <BaseMenu
      key={userId}
      menuItems={menuItems}
      menuAnchor={menuAnchor}
      isMenuOpened={isMenuOpened}
      handleOpenMenu={handleOpenMenu}
      handleCloseMenu={handleCloseMenu}
    />
  );
};
